module.exports = __webpack_public_path__ + "media/lifesum-intro-de-95d475ed.mp4";